import Post from "./Post";
import { PostI, ReleasePost } from "./PostTypes";


export type {
  PostI,
  ReleasePost,
};

export default Post;